<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Estadísticas de Pedidos</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button v-if="campaign" class="btn btn-neutral btn-sm btn-wd" title="Descargar" @click="downloadPdf">
            <i class="fas fa-download"></i>&nbsp;Descargar PDF
          </button>
          <button v-if="campaign" class="btn base-button btn-neutral btn-sm" @click="campaign = null">
            Cambiar Campaña
          </button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para ver estadisticas de los pedidos</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign" class="row">
        <div class="col-sm-12">
          <variety-campaign-totals-table
            v-if="type === stats[0]"
            ref="VarietyCampaign"
            :campaign="campaign"
            :show-campaign-filter="false"
          >
            <template slot="actions">
              <button class="btn btn-outline-primary btn-sm over-header" @click="type = stats[1]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por distribuidor
              </button>
              <button class="btn btn-outline-warning btn-sm over-header" @click="type = stats[2]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por cultivo
              </button>
              <button class="btn btn-outline-dark btn-sm over-header" @click="type = stats[3]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por asesor técnico
              </button>
            </template>
          </variety-campaign-totals-table>
        </div>

        <div class="col-sm-12">
          <distributors-sells-table v-if="type === stats[1]" ref="Distributors" :campaign-id="campaign">
            <template slot="actions">
              <button class="btn btn-outline-info btn-sm over-header" @click="type = stats[0]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por variedad
              </button>
              <button class="btn btn-outline-warning btn-sm over-header" @click="type = stats[2]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por cultivo
              </button>
              <button class="btn btn-outline-dark btn-sm over-header" @click="type = stats[3]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por asesor técnico
              </button>
            </template>
          </distributors-sells-table>
        </div>

        <div class="col-md-12">
          <crops-totals-table v-if="type === stats[2]" ref="Crops" :campaign="campaign">
            <template slot="actions">
              <button class="btn btn-outline-info btn-sm over-header" @click="type = stats[0]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por variedad
              </button>
              <button class="btn btn-outline-primary btn-sm over-header" @click="type = stats[1]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por distribuidor
              </button>
              <button class="btn btn-outline-dark btn-sm over-header" @click="type = stats[3]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por asesor técnico
              </button>
            </template>
          </crops-totals-table>
        </div>

        <div class="col-md-12">
          <sellers-sells-table v-if="type === stats[3]" ref="Sellers" :campaign="campaign">
            <template slot="actions">
              <button class="btn btn-outline-info btn-sm over-header" @click="type = stats[0]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por variedad
              </button>
              <button class="btn btn-outline-primary btn-sm over-header" @click="type = stats[1]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por distribuidor
              </button>
              <button class="btn btn-outline-warning btn-sm over-header" @click="type = stats[2]">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por cultivo
              </button>
            </template>
          </sellers-sells-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';
import VarietyCampaignTotalsTable from './List/VarietyCampaignTotalsTable';
import DistributorsSellsTable from './List/DistributorsSellsTable';
import SellersSellsTable from './List/SellersSellsTable';
import CropsTotalsTable from './List/CropsTotalsTable';

export default {
  name: 'OrdersStats',
  components: {
    RouteBreadCrumb,
    VarietyCampaignTotalsTable,
    DistributorsSellsTable,
    SellersSellsTable,
    CampaignSelect,
    CropsTotalsTable,
  },

  mixins: [CurrentCampaignMixin],
  data() {
    return {
      stats: ['variety-campaign', 'distributors', 'crops', 'sellers'],
      type: 'variety-campaign',
    };
  },

  watch: {
    type(newValue) {
      this.$store.dispatch('navigation/setSelectedStat', newValue);
    },
  },

  created() {
    this.type = this.$store.state.navigation.statSelected || this.type;
  },

  methods: {
    downloadPdf() {
      switch (this.type) {
        case this.stats[0]: {
          this.$refs.VarietyCampaign.downloadPdf();
          break;
        }
        case this.stats[1]: {
          this.$refs.Distributors.downloadPdf();
          break;
        }
        case this.stats[2]: {
          this.$refs.Crops.downloadPdf();
          break;
        }
        default: {
          this.$refs.Sellers.downloadPdf();
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .over-header {
  z-index: 99999;
}
</style>
